export const useComponentTypesStore = defineStore('componentTypes', {
  state: () => ({
    componentTypes: null as PaginatedComponentType | null,
  }),
  getters: {
    getComponentTypes: (state) => (state.componentTypes !== null ? state.componentTypes.items : []),
  },
  actions: {
    setComponentTypes(componentTypes: PaginatedComponentType) {
      useLocalStorage().setItem('componentTypes', componentTypes);
      this.componentTypes = componentTypes;
    },
    async createComponentType(
      componentType: ComponentTypeCreateUpdate,
    ): Promise<ComponentType | undefined> {
      try {
        const {data} = await apiPostComponentType(componentType);
        pushDataToPaginatedState(this.componentTypes, data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readComponentTypes({
      offset,
      limit,
      search,
    }: {offset?: number; limit?: number; search?: string} = {}): Promise<
      PaginatedComponentType | undefined
    > {
      // Parse the local storage value & set the state.
      const localStorageComponentTypes: PaginatedComponentType | null =
        useLocalStorage().getItem('componentTypes');
      if (localStorageComponentTypes) this.setComponentTypes(localStorageComponentTypes);
      try {
        const {data} = await apiGetComponentTypes(limit, offset, search);
        this.setComponentTypes(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readComponentTypeById(id: string | number): Promise<ComponentType | undefined> {
      const localStorageComponentTypes: PaginatedComponentType | null =
        useLocalStorage().getItem('componentTypes');
      if (localStorageComponentTypes) {
        const foundComponentType = localStorageComponentTypes.items.find(
          (componentType) => componentType.id === id,
        );
        if (foundComponentType !== undefined) return foundComponentType;
      }

      try {
        const {data} = await apiGetComponentType(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateComponentType(
      componentType: ComponentTypeCreateUpdate,
    ): Promise<ComponentType | undefined> {
      try {
        const {data} = await apiPutComponentType(componentType);

        if (this.componentTypes !== null) {
          const index = this.componentTypes.items.findIndex((c) => c.id === data.id);
          this.componentTypes.items[index] = data;
          useLocalStorage().setItem('componentTypes', this.componentTypes);
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteComponentType(id: string | number): Promise<void> {
      try {
        await apiDeleteComponentType(id);

        if (this.componentTypes !== null) {
          const index = this.componentTypes.items.findIndex((c) => c.id === id);
          this.componentTypes.items.splice(index, 1);
          useLocalStorage().setItem('componentTypes', this.componentTypes);
          this.componentTypes.total -= 1;
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
